import BasicSelect from 'further-ui/components/BasicSelect';
import { Vehicle } from 'further-types/lp/vehicle';
import { FC } from 'react';

type VehicleSelectorProps = {
  selectedVehicle: Vehicle;
};

const VehicleSelector: FC<VehicleSelectorProps> = ({ selectedVehicle }) => (
  <BasicSelect
    value={selectedVehicle._id}
    onChange={() => undefined}
    fullWidth
    options={[
      { value: selectedVehicle._id, label: selectedVehicle.vehicleName },
    ]}
    placeholder="Select vehicle"
    disabled
  />
);

export default VehicleSelector;
